<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M10.0013 18.3346C6.07293 18.3346 4.10874 18.3346 2.88836 17.1142C1.66797 15.8939 1.66797 13.9296 1.66797 10.0013C1.66797 6.07293 1.66797 4.10874 2.88836 2.88836C4.10874 1.66797 6.07293 1.66797 10.0013 1.66797C11.167 1.66797 12.1596 1.66797 13.0113 1.69985C12.4343 2.35936 12.0846 3.22284 12.0846 4.16797C12.0846 6.23903 13.7635 7.91797 15.8346 7.91797C16.7798 7.91797 17.6432 7.56832 18.3027 6.99132C18.3346 7.84296 18.3346 8.83563 18.3346 10.0013C18.3346 13.9296 18.3346 15.8939 17.1142 17.1142C15.8939 18.3346 13.9296 18.3346 10.0013 18.3346Z"
      fill="currentColor"
    />
    <path
      d="M18.3359 4.16797C18.3359 5.54868 17.2167 6.66797 15.8359 6.66797C14.4552 6.66797 13.3359 5.54868 13.3359 4.16797C13.3359 2.78726 14.4552 1.66797 15.8359 1.66797C17.2167 1.66797 18.3359 2.78726 18.3359 4.16797Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'MessagesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>